module.exports = __webpack_public_path__ + "static/img/6-01.73b7ea5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/6-01.png
// module id = 179
// module chunks = 1